import { Injectable } from '@angular/core';
import { RegbpService } from '../api/src/app/services/regbp.service';
import { Observable, of, throwError } from "rxjs";
import { Profile, StaffProfile } from "..";
import { catchError, map, tap } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class LoginDataFacade {
  constructor(public regbpService: RegbpService) {}

  getLoginData(lang: string, UUID?: string, authType?): Observable<Profile> {
    console.log("getLoginData start in loginDataFacade for authType: " + authType);
    return this.regbpService.getLoginData(lang, UUID, authType).pipe(
      // tap(result => {console.log("out");} ),
      map((results: any) => {
        let profile = results.$response.body.items[0];
        console.log("returning profile from loginDataFacade");
        return profile;
      }),
      catchError((err) => {
        // not logged in so redirect to login page with the return url
        console.error("Found Error @ LoginDataFacade.getLoginData() : " );
        console.error(err);
        return throwError(err);
      })
    );
  }
}

